module.exports = __webpack_public_path__ + "img/client_request.e9305493.svg";